import createBaseRendererServerMessages from "./createBaseRendererServerMessages";

export default createBaseRendererServerMessages({
  name: "projekt",
  kodKey: "nazev"
});
